import gt from "@/component/GetTokenValue";
import { createRouter, createWebHistory } from "vue-router";
// 레이아웃
import ErrorLayout from "@/layout/ErrorLayout.vue";
import PageLayout from "@/layout/PageLayout.vue";

//dashboard page
import Dashboard from "@/views/dashboard/Dashboard.vue";
//키워드 검색 결과 페이지
import KeywordResult from "@/views/dashboard/KeywordResult.vue";

//마이페이지
import MyPage from "@/views/myPage/MyPage.vue";
//회원탈퇴
import RemoveMember from "@/views/myPage/RemoveMember.vue";
//회원가입 유형선택
import JoinType from "@/views/member/JoinType.vue";
//본인 인증
import Auth from "@/views/member/Auth.vue";
//아이디 및 비밀번호 찾기 본인인증
import FindMemberInfo from "@/views/member/FindMemberInfo.vue";
//비회원 본인 인증 및 로그인
import NonMember from "@/views/member/NonMember.vue";
//외국인 인증
import Foreigners from "@/views/member/Foreigners.vue";
//만 14세 미만 인증
import ChildAuth from "@/views/member/ChildAuth.vue";
//신고자 회원가입
import JoinReporter from "@/views/member/JoinReporter.vue";
// 제조사 회원가입
import JoinManufacturer from "@/views/member/JoinManufacturer.vue";
//취약점 처리 절차
import Vulnerability from "@/views/about/Vulnerability.vue";
//핵더 챌린지 분석 플랫폼
import Hackthechallenge from "@/views/about/Hackthechallenge.vue";
//법률 안내
import Law from "@/views/about/Law.vue";
// 이용 가이드
import Guide from "@/views/about/Guide.vue";
//공동 운영 제도
import Operation from "@/views/overview/Operation.vue";
// 공동 운영사 소개
import OperationIntro from "@/views/overview/OperationIntro.vue";
// 공동 운영사 신고 범위
import OperationRange from "@/views/overview/OperationRange.vue";
// 자주 묻는 질문
import Faq from "@/views/overview/Faq.vue";
// 명예의 전당
import Honor from "@/views/overview/Honor.vue";
//보안 취약점 신고포상제
import Bugbounty from "@/views/overview/Bugbounty.vue";
//취약점 신고 접수(국내)
import CommonUser from "@/views/report/submission/CommonUser.vue";
//취약점 신고 접수(해외)
import ForeignUser from "@/views/report/submission/ForeignUser.vue";
//취약점 신고 결과 조회
import ReportRecordDetail from "@/views/report/records/RecordDetail.vue";
import ReportRecord from "@/views/report/records/Records.vue";
//핵더 챌린지 분석 플랫폼 접속
import ReportHackthechallengeAccess from "@/views/report/HacktheChallengeAccess.vue";
//제조사 패치 접수
import PatchTab from "@/views/patch/PatchTab.vue";
//제조사 패치 관리
import patchRecord from "@/views/patch/Records.vue";
// 패치 > 핵더챌린지 분석플랫폼
import PatchHackthechallengeAccess from "@/views/patch/HacktheChallengeAccess.vue";
// 공지사항
import Notice from "@/views/info/Notice.vue";
import NoticeDetail from "@/views/info/NoticeDetail.vue";
//보안 공지
import VulnNotice from "@/views/info/VulnNotice.vue";
import VulnNoticeDetail from "@/views/info/VulnNoticeDetail.vue";
// 공개된 취약점
import VulnPublic from "@/views/info/VulnPublic.vue";
import VulnPublicDetail from "@/views/info/VulnPublicDetail.vue";

//마이페이지 > 취약점 신고 결과 조회
import Result from "@/views/myPage/Result.vue";
//마이페이지 > 취약점 신고 통계 및 접수 내역
import Stats from "@/views/myPage/Stats.vue";
// 마이페이지 > 취약점 패치 통계 및 이력
import PatchResult from "@/views/myPage/PatchResult.vue";
// 내PC 취약점 검사
import SecurityScan from "@/views/scanner/SecurityScan.vue";
import SecurityScanDetail from "@/views/scanner/SecurityScanDetail.vue";

// Rss
import Rss from "@/views/footer/Rss.vue";
//개인정보 처리방침 페이지
import PrivacyPolicy from "@/views/footer/PrivacyPolicy.vue";

const routes = [
  {
    path: "/:pathMatch(.*)*",
    redirect: "/", // 홈으로 리다이렉트
  },
  {
    path: "/",
    name: "DashboardLayout",
    component: PageLayout, //Header + footer
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard,
      },
      {
        path: "keywordResult",
        name: "keywordResult",
        component: KeywordResult,
      },
    ],
  },

  {
    path: "/",
    name: "PageLayout",
    component: PageLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "about/vulnerability",
        name: "vulnerability",
        component: Vulnerability,
      },
      {
        path: "about/hackthechallenge",
        name: "hackthechallenge",
        component: Hackthechallenge,
      },
      {
        path: "about/law",
        name: "law",
        component: Law,
      },
      {
        path: "about/guide",
        name: "guide",
        component: Guide,
      },
      {
        path: "overview/bugbounty",
        name: "bugbounty",
        component: Bugbounty,
      },
      {
        path: "overview/operation",
        name: "operation",
        component: Operation,
      },
      {
        path: "overview/operation/intro",
        name: "operationIntro",
        component: OperationIntro,
      },
      {
        path: "overview/operation/range",
        name: "operationRange",
        component: OperationRange,
      },
      {
        path: "overview/faq",
        name: "faq",
        component: Faq,
      },
      {
        path: "overview/honor",
        name: "honor",
        component: Honor,
      },
      {
        path: "report/submission",
        name: "reportCommonUser",
        component: CommonUser,
        meta: { requiresAuth: true, role: ["REPORT", "NONMEMBER"], guestType: "domestic" },
      },
      {
        path: "report/foreigners/submission",
        name: "reportForeignUser",
        component: ForeignUser,
        meta: { requiresAuth: true, role: "NONMEMBER", guestType: "foreigner" },
      },
      {
        path: "report/records",
        name: "reportRecord",
        component: ReportRecord,
        meta: { requiresAuth: true, role: "REPORT" },
      },
      {
        path: "report/records/detail",
        name: "reportRecordDetail",
        component: ReportRecordDetail,
        meta: { requiresAuth: true, role: "REPORT" },
      },
      {
        path: "report/hackthechallenge/access",
        name: "reportHackthechallengeAccess",
        component: ReportHackthechallengeAccess,
        meta: { requiresAuth: true, role: "REPORT" },
      },
      {
        path: "patch/submission",
        name: "patchSubmission",
        component: PatchTab,
        meta: { requiresAuth: true, role: "PATCH" },
      },
      {
        path: "patch/records",
        name: "patchRecord",
        component: patchRecord,
        meta: { requiresAuth: true, role: "PATCH" },
      },
      {
        path: "patch/records/detail",
        name: "patchRecordDetail",
        component: PatchTab,
        meta: { requiresAuth: true, role: "PATCH" },
      },
      {
        path: "patch/hackthechallenge/access",
        name: "patchHackthechallengeAccess",
        component: PatchHackthechallengeAccess,
        meta: { requiresAuth: true, role: "PATCH" },
      },
      {
        path: "info/notice",
        name: "notice",
        component: Notice,
      },
      {
        path: "info/notice/detail",
        name: "noticeDetail",
        component: NoticeDetail,
        meta: {
          reuse: true,
        },
      },
      {
        path: "info/vuln/public",
        name: "vulnPublic",
        component: VulnPublic,
      },
      {
        path: "info/vuln/public/detail",
        name: "vulnPublicDetail",
        component: VulnPublicDetail,
        meta: {
          reuse: true,
        },
      },
      {
        path: "info/vuln/notice",
        name: "vulnNotice",
        component: VulnNotice,
      },
      {
        path: "info/vuln/notice/detail",
        name: "vulnNoticeDetail",
        component: VulnNoticeDetail,
        meta: {
          reuse: true,
        },
      },
      {
        path: "security/scan",
        name: "securityScan",
        component: SecurityScan,
        meta: { requiresAuth: true },
      },

      {
        path: "security/scan/detail",
        name: "securityScanDetail",
        component: SecurityScanDetail,
        meta: { requiresAuth: true },
      },
      {
        path: "member/type",
        name: "joinType",
        component: JoinType,
      },
      {
        path: "member/myPage",
        name: "myPage",
        component: MyPage,
        meta: { requiresAuth: true },
      },
      {
        path: "member/remove",
        name: "RemoveMember",
        component: RemoveMember,
        meta: { requiresAuth: true },
      },
      {
        path: "member/auth",
        name: "auth",
        component: Auth,
      },
      {
        path: "member/find",
        name: "findMemberInfo",
        component: FindMemberInfo,
      },
      {
        path: "member/non",
        name: "nonMember",
        component: NonMember,
      },
      {
        path: "member/foreigners",
        name: "foreigners",
        component: Foreigners,
      },
      {
        path: "member/child",
        name: "childAuth",
        component: ChildAuth,
      },
      {
        path: "member/join/reporter",
        name: "joinReporter",
        component: JoinReporter,
      },
      {
        path: "member/join/manufacturer",
        name: "joinManufacturer",
        component: JoinManufacturer,
      },
      {
        path: "mypage/stats",
        name: "stats",
        component: Stats,
        meta: { requiresAuth: true },
      },
      {
        path: "mypage/result",
        name: "result",
        component: Result,
        meta: { requiresAuth: true },
      },
      {
        path: "member/patchResult",
        name: "patchResult",
        component: PatchResult,
        meta: { requiresAuth: true },
      },
      {
        path: "footer/rss",
        name: "rss",
        component: Rss,
      },
      {
        path: "footer/privacyPolicy",
        name: "privacyPolicy",
        component: PrivacyPolicy,
      },
    ],
  },
  {
    path: "/error",
    name: "error",
    component: ErrorLayout,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 항상 최상단으로 이동
    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  sessionStorage.setItem("prevPage", from.name);

  const requiresAuth = to.meta?.requiresAuth;

  if (!requiresAuth) {
    return next();
  }

  if (
    to.name === "securityScan" &&
    gt.hasToken() &&
    process.env.VUE_APP_IS_SCANNER_VIEW === "false"
  ) {
    sessionStorage.setItem("errorType", "guide");
    sessionStorage.setItem("errorTitle", "서비스 준비중");
    sessionStorage.setItem("errorMsg", "해당 페이지는 현재 개발중입니다. 다음에 다시 시도해 주시기 바랍니다.");
    return next({ name: "error" });
  }

  if (gt.hasToken()) {
    const role = to.meta?.role;
    if (role == null || role.includes(gt.getRole())) {
      return next();
    }
  }

  if (to.name === "error") {
    return next();
  }

  sessionStorage.setItem("errorType", "warn");
  sessionStorage.setItem("errorTitle", "접근 권한 오류");
  sessionStorage.setItem(
    "errorMsg",
    "해당 페이지에 접근 권한이 없습니다.\n로그인 후 이용해주시기 바랍니다."
  );
  return next({ name: "error" });
});

router.afterEach((to, from) => {
  navigator.sendBeacon(
    process.env.VUE_APP_API_BASE_URL +
    "/core/pu/history/page/add?path=" +
    encodeURIComponent(to.path)
  );
});

export default router;
